import { combineReducers } from "redux";

import { AppState } from "src/redux/state";
import { uiReducer } from "src/redux/ui/reducer";
import { householdClaimReducer } from "src/redux/claim/household/reducer";

export const rootReducer = combineReducers<AppState>({
    ui: uiReducer,
    householdClaims: householdClaimReducer,
});
